module.exports = __webpack_public_path__ + "assets/img/icon_3.e65a9e1c.png";